import { Html, Float } from "@react-three/drei";
import * as THREE from "three";
import { useFrame, useThree } from "@react-three/fiber";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMusic,
  faLink,
  faCartShopping,
  faSearch,
  faVideo,
} from "@fortawesome/free-solid-svg-icons";

import { useRef, useState, Suspense } from "react";
import { Typography } from "antd";
import ExplosionConfetti from "./Confetti.jsx";

import { Planes } from "./Planes";
import { Cars } from "./Cars.jsx";
import Sound from "./Sound";

var clickcount = 0;
var clickcountevents = 0;
var string = "";
var stringevents = "";

export function PopupAcochill(props) {
  const { camera } = useThree();

  const htmlrefcamp = useRef();
  const htmlrefparking = useRef();
  const htmlrefasset = useRef();
  const htmlrefsign = useRef();
  const htmlrefsound = useRef();
  const htmlrefmainboard = useRef();

  const [issoundplaying, setsoundPlaying] = useState(false);

  function handleMouseEnter() {
    setsoundPlaying(true);
  }

  function handleMouseLeave() {
    setsoundPlaying(false);
  }

  function opacityfulltank() {
    const textcamp = document.querySelector("#text-tank-container");
    textcamp.style.opacity = 1;
  }

  function opacityzerotank() {
    const textcamp = document.querySelector("#text-tank-container");
    textcamp.style.opacity = 0;
  }

  function opacityfullasset() {
    const textcamp = document.querySelector("#text-asset-container");
    textcamp.style.opacity = 1;
  }

  function opacityzeroasset() {
    const textcamp = document.querySelector("#text-asset-container");
    textcamp.style.opacity = 0;
  }

  function opacityfullsignboard() {
    const textcamp = document.querySelector("#text-signboard-container");
    textcamp.style.opacity = 1;
  }

  function opacityzerosignboard() {
    const textcamp = document.querySelector("#text-signboard-container");
    textcamp.style.opacity = 0;
  }

  useFrame(({ camera }) => {
    if (
      !htmlrefcamp.current &&
      !htmlrefasset.current &&
      !htmlrefsign.current &&
      !htmlrefsound.current &&
      !htmlrefmainboard.current
    ) {
      return;
    }

    htmlrefcamp.current.quaternion.copy(camera.quaternion);
    htmlrefasset.current.quaternion.copy(camera.quaternion);
    htmlrefsign.current.quaternion.copy(camera.quaternion);
    htmlrefsound.current.quaternion.copy(camera.quaternion);
    htmlrefmainboard.current.quaternion.copy(camera.quaternion);
  }, []);

  return (
    <>
      <ExplosionConfetti
        rate={3}
        fallingHeight={40}
        amount={20}
        enableShadows
        isExploding={issoundplaying}
      />

      {/* { Acochill Whiskey tank Button  } */}
      <mesh ref={htmlrefcamp} scale={[5, 5, 5]} position={[16, -22, 259]}>
        <boxGeometry args={[5, 5, 5]} />
        <meshStandardMaterial side={THREE.DoubleSide} visible={false} />
        <Float speed={7} floatingRange={[5, 5.1]} rotationIntensity={0.01}>
          <Html distanceFactor={1.4} position={[0.4, 0.5, 3.4]} transform>
            <div
              id="container"
              onMouseEnter={() => opacityfulltank()}
              onMouseLeave={() => opacityzerotank()}
              style={{color:"white"}}
            >
              <div id="magnifying-glass"></div>
            </div>
          </Html>
        </Float>
      </mesh>

      {/* { Acochill Asset Button  } */}
      <mesh ref={htmlrefasset} scale={[5, 5, 5]} position={[8.5, -18, 280]}>
        <boxGeometry args={[5, 5, 5]} />
        <meshStandardMaterial side={THREE.DoubleSide} visible={false} />
        <Float speed={7} floatingRange={[5, 5.1]} rotationIntensity={0.01}>
          <Html distanceFactor={13} position={[0.4, 0.5, 3.4]}>
            <div
              id="container"
              onMouseEnter={() => opacityfullasset()}
              onMouseLeave={() => opacityzeroasset()}
            >
              <div id="magnifying-glass"></div>
            </div>
          </Html>
        </Float>
      </mesh>

      {/* { Acochill Signboard Button  } */}
      <mesh ref={htmlrefsign} scale={[5, 5, 5]} position={[17, -19, 287]}>
        <boxGeometry args={[5, 5, 5]} />
        <meshStandardMaterial side={THREE.DoubleSide} visible={false} />
        <Float speed={7} floatingRange={[5, 5.1]} rotationIntensity={0.01}>
          <Html distanceFactor={13} position={[0.4, 0.5, 3.4]}>
            <div
              id="container"
              onMouseEnter={() => opacityfullsignboard()}
              onMouseLeave={() => opacityzerosignboard()}
            >
              <div id="magnifying-glass"></div>
            </div>
          </Html>
        </Float>
      </mesh>

      {/* { Acochill Sound Button  } */}
      <mesh ref={htmlrefsound} scale={[5, 5, 5]} position={[-2.25, -4.1, 253]}>
        <boxGeometry args={[5, 5, 5]} />
        <meshStandardMaterial side={THREE.DoubleSide} visible={false} />
        <Float speed={7} floatingRange={[5, 5.1]} rotationIntensity={0.1}>
          <Html distanceFactor={100} position={[0.4, 0.5, 3.4]}>
            <div
              id="container-airport"
              style={{ height: "37px", width: "37px" }}
            >
              <FontAwesomeIcon
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                icon={faMusic}
                className="icon"
                style={{ position: "absolute", left: "9px", top: "6px",color:"white" }}
              />
            </div>
          </Html>
        </Float>

        <Suspense fallback={null}>
          <mesh position={[0, 20, 290]}>
            <boxGeometry />
            <meshBasicMaterial />
            <Sound
              position={[0, 20, 240]}
              url={"/celeb.mp3"}
              playSound={issoundplaying}
            />
          </mesh>
        </Suspense>
      </mesh>

      {/* { Acochill MainBoard Button  } */}
      <mesh
        ref={htmlrefmainboard}
        scale={[5, 5, 5]}
        position={[24.6, -1.0, 310]}
      >
        <boxGeometry args={[5, 5, 5]} />
        <meshStandardMaterial side={THREE.DoubleSide} visible={false} />
        <Float speed={7} floatingRange={[5, 5.1]} rotationIntensity={0.01}>
          <Html distanceFactor={50} position={[0.4, 0.5, 3.4]}>
            <div
              id="container-airport"
              style={{ height: "37px", width: "37px" }}
            >
              <a href="https://acochill.com/" target="_blank">
                <FontAwesomeIcon icon={faLink} style={{color:"white"}} className="icon-link" />
              </a>
            </div>
          </Html>
        </Float>
      </mesh>

      {/* { Acochill Youtube Button  } */}
      <mesh
        ref={htmlrefmainboard}
        scale={[5, 5, 5]}
        position={[-1.5, -19, 253]}
      >
        <boxGeometry args={[5, 5, 5]} />
        <meshStandardMaterial side={THREE.DoubleSide} visible={false} />
        <Float speed={7} floatingRange={[5, 5.1]} rotationIntensity={0.01}>
          <Html distanceFactor={70} position={[0.4, 0.5, 3.4]}>
            <div
              id="container-airport"
              style={{ height: "37px", width: "37px" }}
            >
              <a
                href="https://www.youtube.com/watch?v=UjOCPHF0H0k"
                target="_blank"
              >
                <FontAwesomeIcon
                  icon={faVideo}
                  className="icon-link"
                  style={{ left: "8.5px",color:"white" }}
                />
              </a>
            </div>
          </Html>
        </Float>
      </mesh>
    </>
  );
}

export function Airportanimationbutton({ changeaboutustrue }, props) {
  const { camera } = useThree();

  const { Title } = Typography;

  const htmlref = useRef();

  const [isPlaneFlying, setIsPlaneFlying] = useState(false);

  function handleMouseEnter() {
    if (clickcount % 2 == 0) {
      setIsPlaneFlying(true);

      string = "Action!";
    } else {
      setIsPlaneFlying(false);

      string = "Stop!";
    }

    clickcount++;
  }

  useFrame(({ camera }) => {
    if (!htmlref.current) {
      return;
    }
    htmlref.current.quaternion.copy(camera.quaternion);
  }, []);

  return (
    <>
      {/* { Airport animation  Button  } */}
      <mesh ref={htmlref} scale={[5, 5, 5]} position={[23, -10, -320]}>
        <boxGeometry args={[5, 5, 5]} />
        <meshStandardMaterial side={THREE.DoubleSide} visible={false} />
        <Float speed={7} floatingRange={[5, 5.1]} rotationIntensity={0.1}>
          <Html distanceFactor={100} position={[0.4, 0.5, 3.4]}>
            <div id="container-airport" style={{color:"white"}}>
              <div
                onClick={handleMouseEnter}
                className="gg-shape-circle-one"
              ></div>
              <div
                onClick={handleMouseEnter}
                className="gg-shape-circle-two"
              ></div>
              <div
                onClick={handleMouseEnter}
                className="gg-shape-circle-three"
              ></div>
            </div>
          </Html>
        </Float>
      </mesh>

      <Html position={[6, 33, -320]} distanceFactor={150}>
        <div className="action">{string}</div>
      </Html>

      {/* { Airport Link Button  } */}
      <mesh ref={htmlref} scale={[5, 5, 5]} position={[-75, 0, -320]}>
        <boxGeometry args={[5, 5, 5]} />
        <meshStandardMaterial side={THREE.DoubleSide} visible={false} />
        <Float speed={7} floatingRange={[5, 5.1]} rotationIntensity={0.01}>
          <Html distanceFactor={150} position={[0.4, 0.5, 3.4]}>
            <div
              id="container-airport"
              onClick={() => changeaboutustrue()}
              style={{ height: "37px", width: "37px" }}
            >
              <FontAwesomeIcon style={{color:"white"}} icon={faLink} className="icon-link" />
            </div>
          </Html>
        </Float>
      </mesh>

      <Suspense fallback={null}>
        <Planes isPlaneFlying={isPlaneFlying} />
      </Suspense>
    </>
  );
}

export function PopupMountpermanent(props) {
  const { camera } = useThree();

  const htmlreflink = useRef();

  function opacityfulltank() {
    const textcamp = document.querySelector("#text-signboard-mountain");
    textcamp.style.opacity = 1;
  }

  function opacityzerotank() {
    const textcamp = document.querySelector("#text-signboard-mountain");
    textcamp.style.opacity = 0;
  }

  useFrame(({ camera }) => {
    if (!htmlreflink.current) {
      return;
    }
    htmlreflink.current.quaternion.copy(camera.quaternion);
  }, []);

  return (
    <>
      {/* { MountFuji Link Button  } */}
      <mesh ref={htmlreflink} scale={[5, 5, 5]} position={[12, 20, 0]}>
        <boxGeometry args={[5, 5, 5]} />
        <meshStandardMaterial side={THREE.DoubleSide} visible={false} />
        <Float speed={7} floatingRange={[5, 5.1]} rotationIntensity={0.1}>
          <Html distanceFactor={160} position={[0.4, 0.5, 3.4]}>
            <div
              id="container-airport"
              style={{ height: "37px", width: "37px" }}
            >
              <a href="https://mtfujitrailstation.com/" target="_blank">
                <FontAwesomeIcon style={{color:"white"}} icon={faLink} className="icon-link" />
              </a>
            </div>
          </Html>
        </Float>
      </mesh>

      {/* { MountFuji Link two Button 85, -20, 163  } */}
      <mesh ref={htmlreflink} scale={[5, 5, 5]} position={[35, -20, 164]}>
        <boxGeometry args={[5, 5, 5]} />
        <meshStandardMaterial side={THREE.DoubleSide} visible={false} />
        <Float speed={7} floatingRange={[5, 5.1]} rotationIntensity={0.1}>
          <Html distanceFactor={100} position={[0.4, 0.5, 3.4]}>
            <div
              id="container-airport"
              style={{ height: "37px", width: "37px" }}
            >
              <a href="https://mtfuji100.com/" target="_blank">
                <FontAwesomeIcon style={{color:"white"}} icon={faLink} className="icon-link" />
              </a>
            </div>
          </Html>
        </Float>
      </mesh>

      {/* { MountFuji Cart Button  } */}
      <mesh ref={htmlreflink} scale={[5, 5, 5]} position={[53, -10, 130]}>
        <boxGeometry args={[5, 5, 5]} />
        <meshStandardMaterial side={THREE.DoubleSide} visible={false} />
        <Float speed={7} floatingRange={[5, 5.1]} rotationIntensity={0.1}>
          <Html distanceFactor={100} position={[0.4, 0.5, 3.4]}>
            <div
              id="container-airport"
              style={{ height: "37px", width: "37px" }}
            >
              <a
                href="https://craviton.com/products/detail/1490"
                target="_blank"
              >
                <FontAwesomeIcon style={{color:"white"}} icon={faCartShopping} className="icon-link" />
              </a>
            </div>
          </Html>
        </Float>
      </mesh>

      {/* { MountFuji Search Button  } */}
      <mesh ref={htmlreflink} scale={[5, 5, 5]} position={[85, -21, 163]}>
        <boxGeometry args={[5, 5, 5]} />
        <meshStandardMaterial side={THREE.DoubleSide} visible={false} />
        <Float speed={7} floatingRange={[5, 5.1]} rotationIntensity={0.1}>
          <Html distanceFactor={80} position={[0.4, 0.5, 3.4]}>
            <div
              id="container-airport"
              onMouseEnter={() => opacityfulltank()}
              onMouseLeave={() => opacityzerotank()}
              style={{ height: "37px", width: "37px" }}
            >
              <FontAwesomeIcon
                icon={faSearch}
                className="icon-link"
                style={{ left: "10px",color:"white" }}
              />
            </div>
          </Html>
        </Float>
      </mesh>

      {/* { MountFuji Instagram Button  } */}
      <mesh ref={htmlreflink} scale={[5, 5, 5]} position={[7, -18, 179]}>
        <boxGeometry args={[5, 5, 5]} />
        <meshStandardMaterial side={THREE.DoubleSide} visible={false} />
        <Float speed={7} floatingRange={[5, 5.1]} rotationIntensity={0.1}>
          <Html distanceFactor={100} position={[0.4, 0.5, 3.4]}>
            <div
              id="container-airport"
              style={{ height: "37px", width: "37px",color:"white" }}
            >
              <a href="https://www.instagram.com/mt.fuji100/" target="_blank">
                <div style={{color:"white"}} className="gg-instagram-container">
                  <div className="gg-instagram"></div>
                </div>
              </a>
            </div>
          </Html>
        </Float>
      </mesh>
    </>
  );
}

export function Interprotoseriesbutton(props) {
  const { camera } = useThree();

  const htmlref = useRef();
  const [iscarrunning, setIsCarRunning] = useState(false);

  function handleMouseEnter() {
    if (clickcountevents % 2 == 0) {
      setIsCarRunning(true);

      stringevents = "Action!";
    } else {
      setIsCarRunning(false);

      stringevents = "Stop!";
    }

    clickcountevents++;
  }

  useFrame(({ camera }) => {
    if (!htmlref.current) {
      return;
    }
    htmlref.current.quaternion.copy(camera.quaternion);
  }, []);

  return (
    <>
      {/* { Interproto animation button  } */}
      <mesh ref={htmlref} scale={[5, 5, 5]} position={[350, -5, 100]}>
        <boxGeometry args={[5, 5, 5]} />
        <meshStandardMaterial side={THREE.DoubleSide} visible={false} />
        <Float speed={7} floatingRange={[5, 5.1]} rotationIntensity={0.1}>
          <Html distanceFactor={100} position={[0.4, 0.5, 3.4]}>
            <div style={{color:"white"}} id="container-airport">
              <div
                onClick={handleMouseEnter}
                className="gg-shape-circle-one"
              ></div>
              <div
                onClick={handleMouseEnter}
                className="gg-shape-circle-two"
              ></div>
              <div
                onClick={handleMouseEnter}
                className="gg-shape-circle-three"
              ></div>
            </div>
          </Html>
        </Float>
      </mesh>

      <Html position={[350, 30, 106]} distanceFactor={150}>
        <div className="actionevents">{stringevents}</div>
      </Html>

      <Suspense fallback={null}>
        <Cars isPlaneFlying={iscarrunning} />
      </Suspense>

      <mesh ref={htmlref} scale={[5, 5, 5]} position={[350, 1, 200]}>
        <boxGeometry args={[5, 5, 5]} />
        <meshStandardMaterial side={THREE.DoubleSide} visible={false} />
        <Float speed={7} floatingRange={[5, 5.1]} rotationIntensity={0.1}>
          <Html distanceFactor={150} position={[0.4, 0.5, 3.4]}>
            <div
              id="container-airport"
              style={{ height: "37px", width: "37px" }}
            >
              <a href="https://drivingathlete.com/" target="_blank">
                <FontAwesomeIcon style={{color:"white"}} icon={faLink} className="icon-link" />
              </a>
            </div>
          </Html>
        </Float>
      </mesh>
    </>
  );
}

export function PopupIsland(props) {
  const { camera } = useThree();

  const htmlreflink = useRef();

  function opacityfulltank() {
    const textcamp = document.querySelector("#text-signboard-mountain");
    textcamp.style.opacity = 1;
  }

  function opacityzerotank() {
    const textcamp = document.querySelector("#text-signboard-mountain");
    textcamp.style.opacity = 0;
  }

  useFrame(({ camera }) => {
    if (!htmlreflink.current) {
      return;
    }
    htmlreflink.current.quaternion.copy(camera.quaternion);
  }, []);

  return (
    <>
      <mesh ref={htmlreflink} scale={[5, 5, 5]} position={[-358, -5, 121]}>
        <boxGeometry args={[5, 5, 5]} />
        <meshStandardMaterial side={THREE.DoubleSide} visible={false} />
        <Float speed={7} floatingRange={[5, 5.1]} rotationIntensity={0.06}>
          <Html distanceFactor={150} position={[0.4, 0.5, 3.4]}>
            <div
              id="container-airport"
              style={{ height: "37px", width: "37px", transform: "scale(.5)" }}
            >
              <a href="https://fuji-takasago.com/" target="_blank">
                <FontAwesomeIcon style={{color:"white"}} icon={faLink} className="icon-link" />
              </a>
            </div>
          </Html>
        </Float>
      </mesh>

      <mesh ref={htmlreflink} scale={[5, 5, 5]} position={[-240, -10, 100]}>
        <boxGeometry args={[5, 5, 5]} />
        <meshStandardMaterial side={THREE.DoubleSide} visible={false} />
        <Float speed={7} floatingRange={[5, 5.1]} rotationIntensity={0.06}>
          <Html distanceFactor={70} position={[0.4, 0.5, 3.4]}>
            <div
              id="container-airport"
              onClick={() => props.goToPosters()}
              // onMouseEnter={() => opacityfulltank()}
              // onMouseLeave={() => opacityzerotank()}
              style={{ height: "37px", width: "37px", transform: "scale(2.2)" }}
            >
              <FontAwesomeIcon
                icon={faSearch}
                className="icon-link"
                style={{ position: "absolute", left: "9.5px",color:"white" }}
              />{" "}
            </div>
          </Html>
        </Float>
      </mesh>
    </>
  );
}
